module.exports = __webpack_public_path__ + "static/assets/7dbb230934c3502349f0c82096268691.png";